import { CopyValue } from 'components/CopyValue';
import { DetailLink } from 'components/DetailsView/DetailLink';
import { DetailValue } from 'components/DetailsView/DetailValue';
import { DynamicDeliveryTag } from 'components/DynamicDeliveryTag';
import { SectionColumn, SectionContainer, ColumnsSectionContainer } from 'components/DetailsView/Section';
import { StatusTag } from '../components/StatusTag';

import { SiteSetupFragmentFragment } from 'data/__generated__';
import { getExtendedFormattedDatetime } from 'helpers/dateTimes';

export const GeneralInfoSection = ({
    boxOperators,
    siteSetup,
}: {
    boxOperators: string;
    siteSetup: SiteSetupFragmentFragment;
}) => {
    const { _id, createdAt, updatedAt, date, state, site, siteId, deliveryPerson, deliveryId, delivery } = siteSetup;
    return (
        <SectionContainer title="Informations générales" isInitiallyOpen>
            <ColumnsSectionContainer numberOfColumns={2}>
                <SectionColumn>
                    <CopyValue value={_id} />
                    <DetailValue
                        label="Date"
                        value={
                            <span className="inline-flex items-center gap-1.5">
                                {date}
                                <DynamicDeliveryTag isDynamic={delivery?.isDynamic} label="Rangement dynamique" />
                            </span>
                        }
                    />
                    <DetailLink label="Site" path="site" name={site.name} value={siteId} />
                    <DetailLink label="Livraison" path="delivery" name={deliveryId} value={deliveryId} />
                    <DetailValue label="Opérateur des caisses" value={boxOperators || '-'} />
                    <DetailLink
                        label="Opérateur"
                        path="user"
                        name={deliveryPerson?.fullname}
                        value={deliveryPerson?._id}
                    />
                </SectionColumn>
                <SectionColumn>
                    <DetailValue label="Date de création" value={getExtendedFormattedDatetime(createdAt)} />
                    <DetailValue label="Dernière mise à jour" value={getExtendedFormattedDatetime(updatedAt)} />
                    <StatusTag state={state} showHeading />
                </SectionColumn>
            </ColumnsSectionContainer>
        </SectionContainer>
    );
};
